import { motion } from "framer-motion";
import { services } from "../data";

export default function Services() {
  return (
    <section className="py-4">
      <div className="container py-4">
        <h2 className="text-center display-5 fw-bold mb-5 text-white">Наши услуги</h2>
        <div className="row g-4">
          {services && services.length > 0 ? (
            services.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                viewport={{ once: true }}
                className="col-md-6 col-lg-4"
              >
                <div className="card h-100 shadow-sm border-0 rounded-4 p-4 section-transparent">
                  <div className="card-body text-center">
                    <div className="display-1 mb-3">{s.icon}</div>
                    <h3 className="h4 fw-bold mb-2 text-white">{s.title}</h3>
                    <p className="text-danger fw-semibold fs-5">{s.price}</p>
                    <p className="text-white-50">⏱ {s.time}</p>
                  </div>
                </div>
              </motion.div>
            ))
          ) : (
            <p className="text-center">Услуги временно недоступны</p>
          )}
        </div>
      </div>
    </section>
  );
}